import { render } from "./SmsComponent.vue?vue&type=template&id=6e00f7b8&scoped=true"
import script from "./SmsComponent.vue?vue&type=script&lang=js"
export * from "./SmsComponent.vue?vue&type=script&lang=js"

import "./SmsComponent.vue?vue&type=style&index=0&id=6e00f7b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e00f7b8"]])

export default __exports__